import { render } from "./Vms.vue?vue&type=template&id=1dac56f6&scoped=true"
import script from "./Vms.vue?vue&type=script&lang=js"
export * from "./Vms.vue?vue&type=script&lang=js"

import "../assets/css/viver-style.css?vue&type=style&index=0&id=1dac56f6&scoped=true&lang=css&external"
import "./Vms.vue?vue&type=style&index=1&id=1dac56f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dac56f6"]])

export default __exports__